Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.MissingValuesOptionView extends Backbone.View
  template: JST['backbone/templates/customer_visual_mode/charts/missing_values_option']

  events:
    'click .toggle-missing-values': '_toggleMissingValues'

  initialize: ({showAll}) ->
    @showAll = showAll
    @toggleEventName = 'chart:toggleMissingValues'

  render: =>
    @$el.html @template
      displayText: @_buttonLabel()
    @

  getToggleMethod: (chartView) ->
    chartView.toggleMissingValues

  _toggleMissingValues: ->
    @showAll = not @showAll
    @render()
    @trigger(@toggleEventName)

  _buttonLabel: ->
    if @showAll then @_ticketsWithValuesLabel() else @_allTicketsLabel()

  _ticketsWithValuesLabel: ->
    I18n.t 'customer_visual_mode.charts.single_dimension.show_tickets_with_values'

  _allTicketsLabel: ->
    I18n.t 'customer_visual_mode.charts.single_dimension.show_all_tickets'
